export function heroVideoAnimation() {
    let $window = $(window);
    let videoBlockParent = $(".video-block-animation");
    let videoBlock = videoBlockParent.find(".video-holder");
    let videoContainer = videoBlockParent.find(".container");

    $window.on("load scroll", function () {
        let windowWidth = $window.innerWidth();

        if (windowWidth > 1200) {
            let windowHeight = $window.innerHeight();
            let windowHalfHeight = windowHeight / 2;
            let videoBlockParentOffsetTop = videoContainer.offset().top;
            let videoContainerWidth = videoContainer.width();
            let scrollTop = $window.scrollTop();
            let deltaWidth = windowWidth - videoContainerWidth;

            if (scrollTop + windowHalfHeight > videoBlockParentOffsetTop && videoBlockParentOffsetTop > scrollTop) {
                videoBlock.css({
                    "width": videoContainerWidth + Math.ceil(((((scrollTop + windowHalfHeight) - videoBlockParentOffsetTop) / windowHalfHeight) * deltaWidth))
                })
            }
        } else {
            videoBlock.removeAttr("style");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroVideoAnimation.js